import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/doc-return.scss";
import { Button } from "components/common/button";

export const DocReturn = ({
  accountId,
  docReturn,
  isDocumentReturnLoading,
  onDisableDocReturn,
  onEnableDocReturn,
  vip
}) => {
  if (vip) {
    return null;
  }
  return (
    <div>
      <h2>Document return</h2>
      <div>
        We will securely shred and recycle your processed mailed-in documents,
         or you can have your documents returned for just $11 per month.
      </div>
      <div className={ styles["button-container"] }>
        {renderDocReturnButton(accountId, docReturn, isDocumentReturnLoading, onDisableDocReturn, onEnableDocReturn) }
      </div>
    </div>
  );
};

DocReturn.propTypes = {
  accountId: PropTypes.string.isRequired,
  docReturn: PropTypes.bool.isRequired,
  isDocumentReturnLoading: PropTypes.bool.isRequired,
  onDisableDocReturn: PropTypes.func.isRequired,
  onEnableDocReturn: PropTypes.func.isRequired,
  vip: PropTypes.bool.isRequired
};

const renderDocReturnButton = (
  accountId,
  docReturn,
  isDocumentReturnLoading,
  onDisableDocReturn,
  onEnableDocReturn
) => {
  if (docReturn) {
    return (
      <Button
        danger
        loading={ isDocumentReturnLoading }
        onClick={ () => onDisableDocReturn(accountId) }
      >
        Turn off document return
      </Button>
    );
  }
  return (
    <Button
      loading={ isDocumentReturnLoading }
      onClick={ () => onEnableDocReturn(accountId) }
      primary
    >
      Return my documents ($11/month)
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/js/components/settings/doc-return.jsx